import * as React from "react";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useMonth } from "../../../hooks/useMonth";
import { toggleAdvancedFilters } from "../../../store/weatherSearchSlice";
import { ShowMoreAccordion } from "../../shared/base/show-more-accordion";
import { FormSelect, FormSelectProps } from "./select";
import { TemperatureRange, TemperatureRangeProps } from "./temperature-range";

export interface WeatherSearchMainFormProps {
    className?: string;
    hideNumberOfResults?: boolean;
}

export const WeatherSearchMainForm = ({
    className,
    hideNumberOfResults
}: WeatherSearchMainFormProps) => {
    const { setMonth } = useMonth({});
    const monthFromState = useAppSelector((state) => {
        return state.weatherSearch.searchProperties.month.val as string;
    });
    const dispatch = useAppDispatch();
    const results = useAppSelector((state) => {
        return state.weatherSearch.searchResultsExtended;
    });

    const [advancedFilters, setAdvancedFilters] =
        React.useState<boolean>(false);

    React.useEffect(() => {
        const month =
            (monthFromState as string) == "all"
                ? "climate"
                : (monthFromState as string);
        setMonth(month);
    }, [monthFromState]);

    // TODO locale
    return (
        <div className={`flex flex-wrap ${className}`}>
            <StandardSelect prop="continent" label="Where do you want to go?" />
            <StandardSelect prop="month" label="When do you want to go?" />
            <StandardSelect prop="tag" label="What do you want to do?" />
            <StandardSelect prop="rainseason" label="Season" />
            <StandardRange isMulti prop="tmax" propTitle="Day temperature" />
            <StandardRange isMulti prop="tmin" propTitle="Night temperature" />
            <StandardRange isMulti prop="sst" propTitle="Sea temperature" />
            <StandardRange
                isMulti={false}
                prop="wet"
                useBlue={true}
                propTitle="Wet days per month"
            />
            <ShowMoreAccordion
                initialOpen={false}
                onClick={() => {
                    setAdvancedFilters(!advancedFilters);
                    dispatch(toggleAdvancedFilters(!advancedFilters));
                }}
                label={`Advanced filters`}
            />
            {advancedFilters && (
                <>
                    <StandardRange
                        isMulti={false}
                        inverted={true}
                        prop="sunhrs"
                        propTitle="Sun hours"
                    />
                    <StandardRange
                        isMulti={false}
                        inverted={true}
                        prop="dayhrs"
                        propTitle="Day hours"
                    />
                    <StandardRange
                        isMulti={false}
                        useBlue={true}
                        prop="rhm"
                        propTitle="Humidity (%)"
                    />
                    <StandardRange
                        isMulti={false}
                        useBlue={true}
                        prop="ws"
                        propTitle="Wind speed"
                    />
                </>
            )}
            {!hideNumberOfResults && (
                <>
                    <div className="mx-4 mt-4 h-px w-full bg-zinc-300" />
                    <div className="my-2 mx-[4px] w-full p-4 text-center text-[14px] tracking-widest">
                        Sunheron found {results?.length} destinations
                    </div>
                </>
            )}
        </div>
    );
};

const StandardRange = ({
    isMulti,
    prop,
    propTitle,
    inverted,
    useBlue
}: TemperatureRangeProps) => {
    return (
        <TemperatureRange
            prop={prop}
            inverted={inverted}
            propTitle={propTitle}
            isMulti={isMulti}
            useBlue={useBlue}
            className="w-search-form p-search-form"
        />
    );
};
const StandardSelect = (props: FormSelectProps) => {
    return (
        <div className="w-search-form p-search-form flex flex-col">
            <FormSelect {...props}></FormSelect>
        </div>
    );
};
